var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveButtonSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "saveButtonSVG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "save-button-container"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "white-background-save-icon-container",
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "white",
    stroke: "#ACB1B6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "black-background-save-icon-container",
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none",
    stroke: "#ACB1B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "black-save-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1631 12.2272L14.2113 11.1689H26.7894L27.8376 12.2272V31.017L20.5003 26.6271L13.1631 31.017V12.2272ZM15.2594 13.2855V27.3025L20.5003 24.1668L25.7412 27.3025V13.2855H15.2594Z",
    fill: "#272829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "white-save-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1631 12.2272L14.2113 11.1689H26.7894L27.8376 12.2272V31.017L20.5003 26.6271L13.1631 31.017V12.2272ZM15.2594 13.2855V27.3025L20.5003 24.1668L25.7412 27.3025V13.2855H15.2594Z",
    fill: "#none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveButtonSvg);
export default __webpack_public_path__ + "static/media/saveButtonSVG.20c7d686744da90cf96ae8516f7d3ac7.svg";
export { ForwardRef as ReactComponent };